var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-player"},[(!_vm.isRPI)?_c('video',{ref:"video",staticClass:"video-player__video",attrs:{"src":_vm.getUrl(_vm.src),"autoplay":_vm.autoplay,"controls":_vm.controls,"loop":_vm.loop}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70d61aaf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoPlayer/VideoPlayer.vue
// module id = null
// module chunks = 